import { HEDGE_TYPES, HEDGE_STATUSES } from "@loanbossinc/component-library";

const HEDGE_ABBREVIATIONS = {
  CAP: "CAP",
  FLOOR: "FLR",
  RATE: "RATE",
  LOWER: "LWR",
  UPPER: "UPR",
  STRIKE: "STRIKE",
  CREDIT_CHARGE: "CC"
};

const isEmpty = value => (value === undefined || value === null || value === "");

export const findHedgeValue = hedgeDetails => findHedgeValueByHedge(hedgeDetails);
const findHedgeValueByHedge = hedgeDetails => {
  if (!hedgeDetails || !hedgeDetails.hedgeStatusId || !hedgeDetails.hedgeTypeId) {
    return null;
  }

  if (hedgeDetails.hedgeTypeId === HEDGE_TYPES.CAP) {
    const hedgeAbbrev = (hedgeDetails.hedgeStatusId === HEDGE_STATUSES.ACTIVE) ? HEDGE_ABBREVIATIONS.CAP : HEDGE_ABBREVIATIONS.STRIKE;

    return (!isEmpty(hedgeDetails.strike)) ? [{ value: hedgeDetails.strike / 100, abbrev: hedgeAbbrev }] : null;
  }

  if (hedgeDetails.hedgeTypeId === HEDGE_TYPES.FLOOR) {
    return (!isEmpty(hedgeDetails.strike)) ? [{ value: hedgeDetails.strike / 100, abbrev: HEDGE_ABBREVIATIONS.FLOOR }] : null;
  }

  if (hedgeDetails.hedgeTypeId === HEDGE_TYPES.SWAP) {
    switch (hedgeDetails.hedgeStatusId) {
      case HEDGE_STATUSES.ACTIVE:
        return (!isEmpty(hedgeDetails.rate)) ? [{ value: hedgeDetails.rate / 100, abbrev: HEDGE_ABBREVIATIONS.RATE }] : null;

      case HEDGE_STATUSES.WATCH:
        return (!isEmpty(hedgeDetails.creditCharge)) ? [{ value: hedgeDetails.creditCharge / 10000, abbrev: HEDGE_ABBREVIATIONS.CREDIT_CHARGE }] : null;

      default:
        return null;
    }
  }

  if (hedgeDetails.hedgeTypeId === HEDGE_TYPES.COLLAR) {
    const dataArray = [];
    if (!isEmpty(hedgeDetails.floor)) {
      dataArray.push({ value: hedgeDetails.floor / 100, abbrev: HEDGE_ABBREVIATIONS.FLOOR });
    }
    if (!isEmpty(hedgeDetails.strike)) {
      dataArray.push({ value: hedgeDetails.strike / 100, abbrev: HEDGE_ABBREVIATIONS.CAP });
    }

    return !dataArray.length ? null : dataArray;
  }

  if (hedgeDetails.hedgeTypeId === HEDGE_TYPES.CORRIDOR) {
    const dataArray = [];
    if (!isEmpty(hedgeDetails.lowerStrike)) {
      dataArray.push({ value: hedgeDetails.lowerStrike / 100, abbrev: HEDGE_ABBREVIATIONS.LOWER });
    }
    if (!isEmpty(hedgeDetails.upperStrike)) {
      dataArray.push({ value: hedgeDetails.upperStrike / 100, abbrev: HEDGE_ABBREVIATIONS.UPPER });
    }

    return !dataArray.length ? null : dataArray;
  }

  return null;
};

export const findWatchHedgeCost = hedgeDetails => findWatchHedgeCostByDetails(hedgeDetails);
const findWatchHedgeCostByDetails = hedgeDetails => {
  if (!hedgeDetails || !hedgeDetails.hedgeTypeId) {
    return null;
  }
  if (hedgeDetails.hedgeTypeId === HEDGE_TYPES.CAP) {
    return (!isEmpty(hedgeDetails.marketCost)) ? { cost: hedgeDetails.marketCost, hedgeType: HEDGE_TYPES.CAP } : null;
  }
  if (hedgeDetails.hedgeTypeId === HEDGE_TYPES.SWAP) {
    return (!isEmpty(hedgeDetails.marketRate)) ? { cost: hedgeDetails.marketRate / 100, hedgeType: HEDGE_TYPES.SWAP } : null;
  }

  return null;
};

export const getHedgeEscrow = hedgeDetails => getHedgeEscrowByDetails(hedgeDetails);
const getHedgeEscrowByDetails = hedgeDetails => {
  if (!hedgeDetails || !hedgeDetails.hedgeTypeId || !hedgeDetails.hedgeStatusId || !hedgeDetails.dealId || !hedgeDetails.watchHedges.length) {
    return null;
  }
  if (hedgeDetails.hedgeStatusId === HEDGE_STATUSES.ACTIVE && hedgeDetails.hedgeTypeId === HEDGE_TYPES.CAP) {
    // need to redirect to new page when setup
    return `/hedge/free/${hedgeDetails.dealId}/${hedgeDetails.watchHedges[0].id}/escrowLedger`;
  }

  return null;
};

